import { z } from 'zod';

export const EmailValidationSchema = z
  .string()
  .trim()
  .toLowerCase()
  .email('Invalid email address');
